"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toSearchQueryParams = exports.shouldAllowUnmocked = exports.isHttpMockServerEnabled = exports.getGlobalConfig = exports.changeHost = exports.extractHost = exports.extractProtocol = exports.resolveProtocol = exports.resolveHost = exports.extractProp = exports.silent = exports.isAbsoluteUrl = void 0;
const constants_1 = require("./constants");
const env_util_1 = require("./env-util");
function isAbsoluteUrl(url) {
    if (typeof url !== 'string') {
        throw new TypeError(`Expected a \`string\`, got \`${typeof url}\``);
    }
    return /(^https?:)|(^\/\/)/.test(url);
}
exports.isAbsoluteUrl = isAbsoluteUrl;
async function silent(fn) {
    try {
        await fn();
    }
    catch (_a) { }
}
exports.silent = silent;
function extractProp(data, path) {
    return path
        .split('.')
        .filter((prop) => prop)
        .reduce((result, prop) => result[prop], data);
}
exports.extractProp = extractProp;
function resolveHost(opts) {
    if (opts.baseURL) {
        return extractHost(opts.baseURL);
    }
    else if (opts.isSSR) {
        return constants_1.SSR_HOST;
    }
    else if (typeof self !== 'undefined' && !!self.location) {
        return self.location.host;
    }
    else {
        return '';
    }
}
exports.resolveHost = resolveHost;
function resolveProtocol(opts) {
    if (opts.baseURL) {
        return extractProtocol(opts.baseURL);
    }
    else if (opts.isSSR) {
        return constants_1.SSR_PROTOCOL;
    }
    else if (typeof self !== 'undefined' && !!self.location) {
        return self.location.protocol;
    }
    else {
        return '';
    }
}
exports.resolveProtocol = resolveProtocol;
function extractProtocol(url) {
    try {
        const asUrl = new URL(url);
        return asUrl.protocol;
    }
    catch (_a) {
        const hostAndProtocol = extractHostAndProtocolUsingRegExp(url);
        return hostAndProtocol.protocol;
    }
}
exports.extractProtocol = extractProtocol;
function extractHost(url) {
    let asUrl;
    try {
        asUrl = new URL(url);
    }
    catch (_a) {
        // in case of PRURL
        asUrl = new URL(`http:${url}`);
    }
    try {
        return asUrl.host;
    }
    catch (_b) {
        const hostAndProtocol = extractHostAndProtocolUsingRegExp(url);
        return hostAndProtocol.host;
    }
}
exports.extractHost = extractHost;
/**
 * In mobile URL object doesnt implement host / protocol
 * This function will try to resolve the host/protocol using regular expression.
 */
function extractHostAndProtocolUsingRegExp(url) {
    const regExp = new RegExp('^(.*:)//([A-Za-z0-9-.]+)(:[0-9]+)?(.*)$');
    try {
        const urlOptions = regExp.exec(url);
        return { protocol: urlOptions[1], host: urlOptions[2] };
    }
    catch (_a) {
        return { protocol: 'http:', host: '' };
    }
}
function changeHost(urlOrPath, host) {
    let url;
    try {
        url = new URL(urlOrPath);
        url.host = host;
        url.protocol = 'http';
    }
    catch (_a) {
        url = new URL(`http://${host}`);
        url.pathname = urlOrPath;
    }
    return url.toString();
}
exports.changeHost = changeHost;
function getGlobalConfig() {
    const defaultConfig = { httpMockServer: { enabled: false } };
    let globalConfig;
    if ((0, env_util_1.isNode)() && process.env.HTTP_CLIENT_GLOBAL_CONFIG) {
        try {
            globalConfig = JSON.parse(process.env.HTTP_CLIENT_GLOBAL_CONFIG);
        }
        catch (e) { }
    }
    if (!globalConfig) {
        if ((0, env_util_1.isBrowser)()) {
            globalConfig = window._httpClientGlobalConfig;
        }
        else if ((0, env_util_1.isWebWorker)()) {
            // TODO
        }
    }
    return globalConfig || defaultConfig;
}
exports.getGlobalConfig = getGlobalConfig;
function isHttpMockServerEnabled() {
    const globalConfig = getGlobalConfig();
    return globalConfig.httpMockServer.enabled;
}
exports.isHttpMockServerEnabled = isHttpMockServerEnabled;
function shouldAllowUnmocked() {
    const globalConfig = getGlobalConfig();
    return globalConfig.httpMockServer.allowUnmocked;
}
exports.shouldAllowUnmocked = shouldAllowUnmocked;
function toSearchQueryParams(params) {
    return Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .flat()
        .join('&');
}
exports.toSearchQueryParams = toSearchQueryParams;
//# sourceMappingURL=utils.js.map